
import { OptionsItemThemeData, SharedThemeData, VariationThemeData } from "../../types/types";
import { VariationId } from "../screen/TableScreen";
import { AppLocalization } from "../localization/AppLocalization";

// options (items as Record)
import shared_theme from "../data/shared/shared_theme.json";
// statistics, rules, dealComplete
import belote_theme from "../data/belote/belote_theme.json";


export class ThemeDataManager
{
    //

    /**
     * Shared data models:
     * - Options theme data
     */
    public static GetSharedData(): SharedThemeData
    {
        return shared_theme;
    }

    public static GetVariationData(variationId?: VariationId): VariationThemeData
    {
        const curVariationId: VariationId = variationId ?? AppLocalization.GetCurVariationId();
        switch (curVariationId) {
            case VariationId.BELOTE:
            case VariationId.COINCHE:
            case VariationId.CONTREE:
            return belote_theme;
        }
    }

    public static GetOptionsItemThemeDataByItemId(itemId:string, variationId?:VariationId): OptionsItemThemeData | undefined
    {
        const variationThemeData: OptionsItemThemeData = this.GetSharedData().options.itemsById[itemId];
        return variationThemeData;
    }
}